import {
  ApiListResponse,
  FacilityCategoryDTO,
  FacilityCreateDTO,
  FacilityDTO,
  FacilityStatus,
} from "@gymflow/types";
import axios, { AxiosInstance } from "axios";

import { createSortParam } from "../createSortParam";
import { trimFields } from "./features/trimFiels";

export type FacilityApiType = ReturnType<typeof facilityApi>;

const facilityApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const fieldsToTrim = ["name", "description"];

  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
      sort,
    }: {
      readonly extraParams?: {
        readonly status?: FacilityStatus;
        readonly id?: number[];
        readonly name?: string;
        readonly [k: string]: any;
      };
      readonly page?: number;
      readonly limit?: number;
      readonly sort?: {
        readonly field: string;
        readonly desc: boolean;
      };
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      } as any;
      if (sort) {
        config.params.sort = createSortParam(sort);
      }
      return axiosInstance.get<ApiListResponse<FacilityDTO>>(
        `${clubPrefix}facility`,
        config,
      );
    },
    findById(id: number) {
      return axiosInstance.get<FacilityDTO>(`${clubPrefix}facility/${id}`);
    },
    create(newResource: FacilityCreateDTO) {
      return axiosInstance.post<FacilityDTO>(
        `${clubPrefix}facility`,
        trimFields(newResource, fieldsToTrim),
      );
    },
    update(id: number, patchedFields: Partial<FacilityCreateDTO>) {
      return axiosInstance.patch<FacilityDTO>(
        `${clubPrefix}facility/${id}`,
        trimFields(patchedFields, fieldsToTrim),
      );
    },
    deactivate(id: number) {
      return axiosInstance.patch(`${clubPrefix}facility/${id}/inactive`);
    },

    activate(id: number) {
      return axiosInstance.patch(`${clubPrefix}facility/${id}/active`);
    },

    async updatePicture(
      facilityId: number,
      { blob, name }: { blob: string; name: string },
    ) {
      const blobResponse = await axios.get(blob, {
        responseType: "blob",
      });
      const formData = new FormData();
      formData.append("file", blobResponse.data, name);
      return axiosInstance.post(
        `${clubPrefix}facility/${facilityId}/picture`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    },

    fetchCategories() {
      return axiosInstance.get<FacilityCategoryDTO[]>(
        `${clubPrefix}catalog/facility/category`,
      );
    },
    delete(facilityId: number) {
      return axiosInstance.delete(`${clubPrefix}facility/${facilityId}`);
    },
  };
};

export default facilityApi;
